export default {
  default: () => import("/app/src/layouts/default.vue").then(m => m.default || m)
}